import React from 'react'
import LoginForm from '../../features/LoginForm/LoginForm'
import "./Login.scss"

const LoginPage = () => {
  return (
    <LoginForm />
  )
}

export default LoginPage
